import { render, staticRenderFns } from "./RiskToggleBasic.vue?vue&type=template&id=694f55fc&"
import script from "./RiskToggleBasic.vue?vue&type=script&lang=js&"
export * from "./RiskToggleBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports